// extracted by mini-css-extract-plugin
export default {"link":"link__vr8vF","left":"left__KAcOV","right":"right__WFOl9","center":"center__ZsWjk","disabled":"disabled__RGUPY"};